import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PartnerCategory } from 'src/app/assabil-kernel/models/entities/control-tables/partner-category-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';


@Component({
    selector: 'partner-category-list',
    templateUrl: './partner-category-list.component.html',
    styleUrls: ['./partner-category-list.component.scss']
})


export class PartnerCategoryListComponent extends BasePage2<PartnerCategory> {

    partnerCategories: PartnerCategory[] = [];
    code: string;
    name: string;

    constructor(
        protected toastr                : ToastrService,
        protected controlTablesService  : ControlTablesService,
        protected router                : Router,
        protected baseService           : BaseService,
        protected leanUtilsService      : LeanUtilsService, 
        protected location              : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'partnerCategory';
    }


//----------------------------------------------------------------------
ngAfterViewInit(): void {
    super.ngAfterViewInit();
      this.setChildFields();
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
    this.baseService.fieldsGet('partnerCategoryType').then(result => {
          this.childFields = result.listFields;
          this.readOnly    = result.readOnly;
    }) 
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
getRows(): PartnerCategory[] {
    return this.partnerCategories;
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
new(){
    let partnerCategory : PartnerCategory = new PartnerCategory();
    partnerCategory.inserted = true;
    partnerCategory.edit = true;
    this.selectedRow = partnerCategory;
}  
//----------------------------------------------------------------------



//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
        request.strArg1 = this.code;
        request.blnArg1 = false;

        this.controlTablesService.getList(this.entityName, request).then(result => {
            this.partnerCategories = result;
        })
    }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
selectRow(partnerCategory : PartnerCategory){
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = partnerCategory.partnerCategoryCode;
    this.controlTablesService.getSingle(this.entityName, request).then(result => {
        this.selectedRow = result;
    })
  }
//----------------------------------------------------------------------


}
